<template>
  <!-- Static sidebar for desktop -->
  <div class="hidden md:flex md:flex-shrink-0">
    <div
      class="flex flex-col w-64"
      :class="[this.hiddensidebar ? { hidden: true } : {}]"
    >
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div class="flex flex-col flex-1 border-r border-gray-200 bg-white">
        <div class="flex-1 flex flex-col pt-3 pb-4 overflow-y-auto">
          <nav class="flex-1 px-4 bg-white space-y-1">
            <template v-for="nav in navs">
              <sidebar-button
                v-on:click.native="selectNav(nav)"
                v-bind:key="nav.title"
                :to="nav.path"
                :title="nav.title"
                :nav="nav"
              />
            </template>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SidebarButton from '@/components/Sidebar/SidebarButton';
// import { mapState } from 'vuex'
export default {
  components: { SidebarButton },
  props: {
    hiddensidebar: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    console.log('Sidebar')
    if (this.auth.result === 'ok') {
      this.obtainNavs()
    }
  },
  data() {
    return {
      navs: []
    };
  },
  computed: {
    auth() {
      return this.$store.getters.auth;
    }
  },
  watch: {
    auth(data) {
      console.log(data);
      if (data.result !== 'ok') {
        this.$router.push('/login');
      } else {
        this.obtainNavs();
      }
    }
  },
  methods: {
    selectNav(nav) {
      console.log('selectNav!', JSON.stringify(nav));
      this.$store.dispatch('updateCurrentNav', nav);
    },
    async obtainNavs() {
      this.$router.push(this.auth.root);
      await this.$store.dispatch('getNavs');
      this.navs = this.$store.getters.navs;
      console.log(this.navs);
      let selectednav = this.navs.filter(el => {
        return el.path === this.auth.root;
      });
      this.$store.dispatch('updateCurrentNav', selectednav[0]);
    }
  },
};
</script>
